import OATCore from '@sayl/oat-core'

export default ({ debug, store, transports }) => {
  return new Promise((resolve) => {
    debug && console.log('bootstrap.oat.core', 'init');

    const core = new OATCore();
    core.init({ store, transports }).then(() => {
      return resolve();
    }).catch((error) => {
      console.error(error);
    });

    debug && console.log('bootstrap.oat.core', 'completed');

    //return resolve();
  })
}
